import { ApplicationDetailsDto } from '../../../legacy/shared-types';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { applicationsApi } from 'api/applications';
import dayjs from 'dayjs';
import { ApplicationDetailsFormatted, IDocumentFormatted } from './types';

export const applicationDetailsTrasnformer = (application: ApplicationDetailsDto): ApplicationDetailsFormatted => ({
  id: application.id,
  applicant1: `${application.customers[0].firstName} ${application.customers[0].lastName}`,
  applicant2: application.customers[1] && `${application.customers[1].firstName} ${application.customers[1].lastName}`,
  salesforceId: application.referenceNumber,
  financeAmount: application.financeAmount,
  status: application.status,
  ftv: application.ftv,
  propertyAddress:
    application.property &&
    `${application.property.address1}, ${application.property.town}, ${application.property.postcode}`,
  propertyId: application.property?.id || null,
  valuation: application.property?.valuation,
  files: application.docs.reduce<Record<string, IDocumentFormatted[]>>((acc, doc) => {
    if (!acc[doc.source.toLowerCase()]) acc[doc.source.toLowerCase()] = [];

    acc[doc.source.toLowerCase()].push({
      ...doc,
      url: `/${doc.id}`,
      createdAtFormatted: dayjs(doc.createdAt).format('DD/MM/YYYY HH:mm'),
    });

    return acc;
  }, {}),
  notes: application.notes,
});

export const useApplicationByReferenceNumber = (referenceNumber: string): UseQueryResult<ApplicationDetailsFormatted> =>
  useQuery(['analystApplications'], () => applicationsApi.getByReferenceNumber(referenceNumber), {
    select: application => applicationDetailsTrasnformer(application),
  });
